import script from "./demo-day-investor-applications-list.vue?vue&type=script&setup=true&lang=js"
export * from "./demo-day-investor-applications-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__